import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { markAllNotificationFailed, markAllNotificationSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import { returnApplicationFailed, returnApplicationSuccessful } from '../../Application/actions';

export default function* markAllNotification(action) {
  try {
    const url = `${BACKEND_URL}/profile/notifications/mark-all-as-read`;
    const response = yield makeRequest(url, {}, action, 'POST', true);
    if (response.status === NO_CONTENT) {
      yield put(markAllNotificationSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(markAllNotificationFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(markAllNotificationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
